/* eslint-disable react/prop-types */
import { useRef, useCallback } from "react";
import { Modal } from "react-bootstrap";
import { sanitizeBioText } from "./utils";
import "./broker-bio-modal.css";

const DEFAULT_PHOTO = "/assets/images/default_profile.png";

/**
 * BrokerBioModal - Modal with dark header (photo + name) and white body (bio text).
 * Matches Figma: split layout with navy header and clean white bio section.
 */
const BrokerBioModal = ({ show, onHide, broker }) => {
  const triggerRef = useRef(null);

  const handleShow = useCallback(() => {
    triggerRef.current = document.activeElement;
  }, []);

  const handleExited = useCallback(() => {
    if (triggerRef.current) {
      triggerRef.current.focus();
      triggerRef.current = null;
    }
  }, []);

  if (!broker) return null;

  const { firstName, lastName, title, company, photoUrl, bio } = broker;
  const fullName = [firstName, lastName].filter(Boolean).join(" ");

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      dialogClassName="broker-bio-modal"
      aria-labelledby="broker-bio-modal-title"
      enforceFocus
      restoreFocus
      onShow={handleShow}
      onExited={handleExited}
    >
      {/* Dark navy header with photo, name, title, company */}
      <div className="broker-bio-modal__header">
        <img
          src={photoUrl || DEFAULT_PHOTO}
          alt={fullName ? `${fullName} profile photo` : "Broker profile photo"}
          className="broker-bio-modal__header-photo"
          onError={(e) => { e.target.src = DEFAULT_PHOTO; }}
        />
        <div className="broker-bio-modal__header-info">
          <h3 className="broker-bio-modal__header-name" id="broker-bio-modal-title">{fullName}</h3>
          {title && <p className="broker-bio-modal__header-title">{title}</p>}
          {company && <p className="broker-bio-modal__header-company">{company}</p>}
        </div>
        <button
          type="button"
          className="broker-bio-modal__close-btn"
          onClick={onHide}
          aria-label="Close"
        >
          &times;
        </button>
      </div>

      {/* White body with bio */}
      <Modal.Body className="broker-bio-modal__body">
        <h4 className="broker-bio-modal__bio-heading">About {firstName || fullName}</h4>
        {bio && <div className="broker-bio-modal__bio-text" dangerouslySetInnerHTML={{ __html: sanitizeBioText(bio) }} />}
        {!bio && <p className="broker-bio-modal__bio-text">No bio available.</p>}
      </Modal.Body>
    </Modal>
  );
};

export default BrokerBioModal;
